import ESpinner from "components/others/Spinner";
import { Col, Row } from "react-bootstrap";
import vconst from "utils/helpers/structs/vconst";
import WarehouseToolBar from "./WarehouseToolBar";
import WarehouseTable from "./WarehouseTable";
import OffComing from "./OffComing";
import OffTransfer from "./OffTransfer";
import OffWarehouseOperations from "./OffWarehouseOperations";
import { format$Price } from "utils/helpers/functions/formatPrice";
import TitleCounter from "components/others/TitleCounter";
import OffFilter from "./OffFilter";
import OffPayments from "./OffPayments";
import { useWarehousePage } from "./model/useWarehousePage";

const Warehouse = ({ wId }: { wId: number }) => {
    const {
        t,
        auth,
        canOps,
        showCredit,
        stocksList,
        warehouseInfo,
        warehouseHeader,
        balance,
        credit,
        teamId,
        teamName,
        teamDeleted,
        customId,
        customName,
        customDeleted,
        warehouseEmpty,
        showComing,
        setShowComing,
        showTransfer,
        setShowTransfer,
        showFilter,
        handleShowFilter,
        prevFilter,
        setPrevFilter,
        showPaymentsId,
        setShowPaymentsId,
        showPaymentsTitle,
        setShowPaymentsTitle,
        fetchStocks,
        handleTeamChanged,
    } = useWarehousePage(wId);

    return (<>
        <OffWarehouseOperations/>

        <OffFilter
            wId={wId}
            show={showFilter}
            setShow={handleShowFilter}
            setPrevFilter={setPrevFilter}
            prevFilter={prevFilter}/>

        <OffPayments
            showTitle={showPaymentsTitle}
            wId={wId}
            showId={showPaymentsId}
            setShowId={setShowPaymentsId}
            fetchStocks={fetchStocks}/>

        <OffComing
            fetchStocks={fetchStocks}
            show={showComing}
            setShow={setShowComing}/>

        <OffTransfer
            wId={wId}
            teamId={teamId}
            reservObjectId={warehouseInfo?.reservObjectId || null}
            fetchStocks={fetchStocks}
            show={showTransfer}
            setShow={setShowTransfer}/>

        <Row>
            <Col className="col-sticky" sm={12}>
                <div className="w-100 d-flex flex-column flex-xl-row pt-1 justify-content-between align-items-start gap-2 gap-xl-0">
                    <div className="warehouse-header-meta">
                        <div className="warehouse-header-meta__title-row">
                            <h4
                                className="warehouse-header-meta__title text-truncate"
                                title={warehouseHeader.name || warehouseHeader.type || undefined}
                            >
                                {warehouseHeader.name || warehouseHeader.type}
                            </h4>
                            {warehouseHeader.badgeClass && (
                                <span className={`badge fs-12 ${warehouseHeader.badgeClass}`}>
                                    {warehouseHeader.type}
                                </span>
                            )}
                        </div>
                        <div className="warehouse-header-meta__line">
                            {warehouseHeader.name && !warehouseHeader.badgeClass && (
                                <span className={`warehouse-header-meta__type ${warehouseHeader.typeClass}`}>
                                    {warehouseHeader.type}
                                </span>
                            )}
                            <TitleCounter
                                title={t('balance')}
                                count={format$Price(balance || 0)}
                            />
                            {showCredit && auth?.user?.access?.role == 'manager' && wId === vconst.waherouseMainId && (
                                <TitleCounter
                                    color={credit == 0 ? 'success' : credit > 0 ? 'danger' : 'warning'}
                                    title={credit == 0 ? t('noCredit') : credit < 0 ? t('creditPositive') : t('credit')}
                                    count={credit ? format$Price(credit < 0 ? -credit : credit || 0) : undefined}
                                    noShowCount={!Boolean(credit)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="warehouse-header-toolbar">
                        <WarehouseToolBar
                            wId={wId}
                            setShowFilter={handleShowFilter}
                            setShowComing={setShowComing}
                            setShowTransfer={setShowTransfer}
                            teamId={teamId}
                            teamName={teamName}
                            teamDeleted={teamDeleted}
                            customId={customId}
                            customName={customName}
                            customDeleted={customDeleted}
                            warehouseEmpty={warehouseEmpty}
                            warehouseIdApi={warehouseInfo?.warehouseIdApi || null}
                            reservObjectId={warehouseInfo?.reservObjectId || null}
                            reservOnlySale={warehouseInfo?.object?.onlySale}
                            onTeamChanged={handleTeamChanged}/>
                    </div>
                </div>
            </Col>

            <Col sm={12}>
                {stocksList
                    ? (
                        <WarehouseTable
                            wId={wId}
                            setShowComing={setShowComing}
                            setShowPaymentsId={setShowPaymentsId}
                            setShowPaymentsTitle={setShowPaymentsTitle}
                            setShowTransfer={setShowTransfer}
                            onlyView={!canOps}
                            stocksList={stocksList}/>)
                    : (<ESpinner/>)}
            </Col>
        </Row>
    </>)
}

export default Warehouse;
